module.exports = __webpack_public_path__ + "media/images/shared/patricia-robertson-f98b59588e7af8d15dc51fe9867b9e1d5b8e2d6b5c3e5b44acfe95aafd8630ea.png";